/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { z } from 'zod';

// Frontend Filters schema (UI shape):
// days: { mon..sun: boolean }, session: array of [start,end] or {start,end}
export const filtersSchema = z.object({
  days: z.object({
    mon: z.boolean(),
    tue: z.boolean(),
    wed: z.boolean(),
    thu: z.boolean(),
    fri: z.boolean(),
    sat: z.boolean().optional(),
    sun: z.boolean().optional(),
  }),
  session: z.array(
    z.union([
      z.tuple([z.string(), z.string()]),
      z.object({ start: z.string(), end: z.string() })
    ])
  ),
});

export default filtersSchema;
